import React, { useCallback, useEffect } from 'react';
import moment from "moment";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
// @mui

import { Grid, } from '@mui/material';

import TodayIcon from '@mui/icons-material/Today';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';


import { setTime } from "../features/default/defaultSlice";

import {
  AppWidgetNoIcon,
} from '../sections/@dashboard/app';


// ----------------------------------------------------------------------

DateTimePatientCards.propTypes = {
  isCovid19Page: PropTypes.bool
};

export default function DateTimePatientCards(props) {

  const currentTime = useSelector((state) => state.default.time)
  const patientState = useSelector((state) => state.patient)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isCovid19Page } = props;

  const clock = useCallback(() => {
    setInterval(() => {
      dispatch(setTime());
    }, 1000);
  }, [dispatch]);

  useEffect(() => {
    clock();
  }, [clock]);
  
  return (
    <Grid container spacing={3} mb={4}>
      <Grid item sm={6} md={4} sx={{ display: { xs: "none", sm: "block" } }}> 
        <AppWidgetNoIcon
          title="DATE"
          total={moment().format("YYYY-MM-DD")}
          icon={<TodayIcon />}
          onClick={() => navigate( isCovid19Page? '/covid19/dashboard': '/home' , { replace: false })}
          sx={{ boxShadow: 3 }}
          color="secondary" 
          />
      </Grid>

      <Grid item sm={6} md={4} sx={{ display: { xs: "none", sm: "block" } }}>
        <AppWidgetNoIcon 
          title="TIME" 
          total={currentTime} 
          icon={<AccessTimeIcon />} 
          onClick={() => navigate( isCovid19Page? '/covid19/dashboard': '/home' , { replace: false })}
          sx={{ boxShadow: 3 }}
          color="secondary" />
      </Grid>

      <Grid item sm={6} md={4} sx={{ display: { xs: "none", sm: "block" } }}>
        {isCovid19Page ?
          <AppWidgetNoIcon
            title={(patientState.noOfCovid19Patients > 1) ? "COVID-19 PATIENTS" : "COVID-19 PATIENT"}
            total={patientState.noOfCovid19Patients.toString()}
            icon={<PersonOutlineIcon />}
            onClick={() => navigate(`/covid19/patientlist`, { replace: false })}
            sx={{ boxShadow: 3 }}
            color="secondary"
          />
        :
          <AppWidgetNoIcon
            title={(patientState.noOfPatients > 1) ? "PATIENTS" : "PATIENT"}
            total={patientState.noOfPatients.toString()}
            icon={<PersonOutlineIcon />}
            onClick={() => navigate(`/patient/list`, { replace: false })}
            sx={{ boxShadow: 3 }}
            color="secondary"
          />
        }

      </Grid>
    </Grid>
  );
}
